<template>
  <div
    style="
      font-family: sans-serif;
      font-size: 20px;
      line-height: 1.2;
      padding: 20px;
      margin: 0 auto;
      background-color: white;
      color: black;
      font-weight: bold;
    "
  >
    <!-- Company Header -->
    <div style="text-align: center; margin-bottom: 20px">
      <div style="font-size: 60px; font-weight: bold; margin: 0 0 10px 0; text-align: center">
        <img
          v-if="companySettings.logoUrl"
          :src="companySettings.logoUrl"
          :alt="companySettings.name || 'Company Logo'"
          style="width: auto; height: 150px; margin: 10px 0"
        />
        <p v-if="companySettings.address" style="margin: 10px 0; font-size: 30px">
          {{ companySettings.address }}
        </p>
        <p v-if="companySettings.phone" style="margin: 10px 0; font-size: 30px">
          Phone: {{ companySettings.phone }}
        </p>
      </div>
      <p style="font-size: 36px; font-weight: bold; margin: 20px 0">
        {{ transaction.transaction_type === 'purchase' ? 'PURCHASE RECEIPT' : 'SALES RECEIPT' }}
      </p>
      <div
        style="
          font-size: 20px;
          margin: 25px 0;
          text-align: center;
          border-top: 5px solid #000;
          border-bottom: 5px solid #000;
          padding: 10px 0;
        "
      ></div>
    </div>

    <!-- Transaction Info -->
    <div style="margin-bottom: 20px">
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Transaction #:</div>
        <div>{{ transaction.transaction_number }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Date:</div>
        <div>{{ formatDate(transaction.transaction_date) }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Type:</div>
        <div>{{ transaction.transaction_type === 'purchase' ? 'Purchase' : 'Sale' }}</div>
      </div>
      <div
        style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 30px"
      >
        <div style="font-weight: bold">Party:</div>
        <div>{{ partyName }}</div>
      </div>
      <div
        style="
          font-size: 20px;
          margin: 25px 0;
          text-align: center;
          border-top: 5px solid #000;
          padding: 10px 0;
        "
      ></div>
    </div>

    <!-- Transaction Items -->
    <div style="margin-bottom: 20px">
      <div style="font-weight: bold; font-size: 36px; margin-bottom: 15px">ITEMS</div>
      <div style="margin-top: 20px">
        <div v-for="(item, index) in items" :key="index" style="margin-bottom: 30px">
          <div style="font-weight: bold; margin-bottom: 10px; font-size: 30px">
            {{ item.commodity_name }}
          </div>
          <div style="padding-left: 20px">
            <div
              style="display: flex; justify-content: space-between; font-size: 25px; margin: 8px 0"
            >
              <span>Gross: {{ item.weight?.gross || 0 }}</span>
              <span>Tare: {{ item.weight?.tare || 0 }}</span>
              <span>Net: {{ item.weight?.net || 0 }}</span>
            </div>
            <div
              style="display: flex; justify-content: space-between; font-size: 25px; margin: 8px 0"
            >
              <span>Price:</span>
              <span>${{ formatPricePerLb(item.price_per_lb) }}/lb</span>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                font-size: 25px;
                margin: 8px 0;
                font-weight: bold;
              "
            >
              <span>Total:</span>
              <span>{{ formatCurrency(item.total_price || 0) }}</span>
            </div>
          </div>
          <div style="border-top: 1px dashed #000; margin: 15px 0"></div>
        </div>
      </div>
    </div>

    <!-- Totals -->
    <div style="margin-bottom: 20px; margin-top: 20px">
      <div style="display: flex; justify-content: space-between; margin: 10px 0; font-size: 48px; font-weight: bold">
        <div>Total Weight:</div>
        <div>{{ calculateTotalWeight(props.items || []) }} lbs</div>
      </div>
      <div style="display: flex; justify-content: space-between; margin: 10px 0; font-size: 48px; font-weight: bold">
        <div>Total Amount:</div>
        <div>{{ formatCurrency(transaction.total_amount || 0) }}</div>
      </div>
      <div
        style="
          font-size: 20px;
          margin: 25px 0;
          text-align: center;
          border-top: 5px solid #000;
          border-bottom: 5px solid #000;
          padding: 10px 0;
        "

      </div>
    </div>

    <!-- Notes Section -->
    <div style="margin-bottom: 0.1in" v-if="transaction.notes">
      <div style="font-weight: bold; font-size: 11px; margin-bottom: 3px; font-family: 'Courier New', monospace">NOTES</div>
      <div style="font-family: 'Courier New', monospace">{{ transaction.notes }}</div>
      <div style="font-size: 10px; margin: 5px 0; text-align: center; font-family: 'Courier New', monospace"></div>
    </div>

    <!-- Footer -->
    <div style="text-align: center; margin-top: 30px; font-size: 30px">
      <p style="margin: 10px 0; font-size: 30px; font-weight: bold">Thank you for your business!</p>

      <!-- Promo Section -->
      <div v-if="includePromos && companySettings.reviewUrl" style="margin-top: 30px; padding: 20px;">
        <div style="font-size: 36px; font-weight: bold; margin-bottom: 15px;">
          ⭐⭐⭐⭐⭐
        </div>
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">
          Love Your Experience?
        </div>
        <div style="font-size: 20px; margin-bottom: 20px;">
          Leave us a quick Google Review and get<br>
          <span style="font-weight: bold;">+5¢/lb for one item on your next load!</span>
          <p class="text-xs mt-1">*Offer only valid once; for select commodities.</p>
        </div>

        <!-- QR Code with white space -->
        <div style="margin: 20px 0; padding: 20px; background-color: white;">
          <QrCode :url="companySettings.reviewUrl" :size="300" />
        </div>

        <div style="font-size: 18px; margin-top: 15px;">
          <div style="font-weight: bold; margin-bottom: 5px;">⬆️ Scan this with your phone camera</div>
          <div>Or visit <span style="font-weight: bold;">{{ companySettings.reviewUrl }}</span></div>
        </div>
      </div>

      <!-- Simple review request when promos are disabled -->
      <div v-else-if="companySettings.reviewUrl" style="margin-top: 30px; padding: 20px;">
        <div style="font-size: 24px; font-weight: bold; margin-bottom: 10px;">
          Love Your Experience?
        </div>
        <div style="font-size: 20px; margin-bottom: 20px;">
          Leave us a quick Google Review!
        </div>

        <!-- QR Code with white space -->
        <div style="margin: 20px 0; padding: 20px; background-color: white;">
          <QrCode :url="companySettings.reviewUrl" :size="300" />
        </div>

        <div style="font-size: 18px; margin-top: 15px;">
          <div style="font-weight: bold; margin-bottom: 5px;">⬆️ Scan this with your phone camera</div>
          <div>Or visit <span style="font-weight: bold;">{{ companySettings.reviewUrl }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { calculateTotalWeight } from '@/utils/transactionHelper'
import { formatDate, formatDateTime, formatCurrency } from '@/utils/formatters'
import { getPaymentMethodLabel, getPaymentStatusLabel } from '@/utils/labels'
import { useSettingsStore } from '@/stores/settings'
import QrCode from '@/components/common/QrCode.vue'
import type { TransactionRecord } from '@/types/Transaction'
import type { TransactionItem } from '@/types/Transaction'

const props = withDefaults(
  defineProps<{
    transaction: TransactionRecord
    items: TransactionItem[]
    partyData?: Record<string, unknown>
    partyName?: string
    partyAddress?: string
    partyContact?: string
    includePromos?: boolean
  }>(),
  {
    includePromos: true,
  },
)

const settingsStore = useSettingsStore()
const companySettings = computed(() => settingsStore.companySettings)

// Helper function to format price per lb with dynamic precision
// At least 2 decimals, but more if there are more significant digits
function formatPricePerLb(price: number | string): string {
  const numPrice = typeof price === 'string' ? parseFloat(price) : price
  if (isNaN(numPrice)) return '0.00'

  // Round to 6 decimal places first to eliminate floating point artifacts
  // This handles cases like 3.7 being stored as 3.70000000000000017764
  const rounded = Math.round(numPrice * 1000000) / 1000000

  // Check if it's effectively a whole number
  if (Math.abs(rounded - Math.round(rounded)) < 0.000001) {
    return Math.round(rounded).toFixed(2)
  }

  // Find the minimum precision needed by checking the rounded value
  // Start with 6 decimals and work backwards to find the actual precision
  let formatted = rounded.toFixed(6)

  // Remove trailing zeros, but ensure at least 2 decimals
  formatted = formatted.replace(/\.?0+$/, '')

  // Count decimal places
  const decimalIndex = formatted.indexOf('.')
  if (decimalIndex === -1) {
    // No decimal point, add .00
    return rounded.toFixed(2)
  }

  const decimalPlaces = formatted.length - decimalIndex - 1
  // Ensure at least 2 decimals
  if (decimalPlaces < 2) {
    return rounded.toFixed(2)
  }

  return formatted
}
</script>
